import React from "react";
import { useSelector } from "react-redux";
import ProductListCard from "./ProductListCard";

const RecentlyAddedProducts = () => {
  const { recentlyAddedProducts } = useSelector((state) => state.product);

  return (
    <>
      {recentlyAddedProducts && recentlyAddedProducts?.length > 0 && (
        <div
          className="col-xl-3 col-lg-4 col-md-6 mb-sm-5 mb-md-0 d-none d-lg-block wow animate__animated animate__fadeInUp"
          data-wow-delay=".2s"
        >
          <h4 className="section-title style-1 mb-30 animated animated">
            Recently added
          </h4>
          <div className="product-list-small animated animated">
            {recentlyAddedProducts.map((item, index) => (
              <ProductListCard key={index} item={item} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RecentlyAddedProducts;
